import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { SurgeryModel } from 'app/EMR/DoctorModels/surgery.model';
import { EMRService } from 'app/EMR/EMR.service';
import { AddNewSurgeryComponent } from 'app/EMR/NewSurgery/add-new-surgery/add-new-surgery.component';
import { NewSurgeryComponent } from 'app/EMR/NewSurgery/NewSurgery.component';
import { HelplistService } from 'app/helplist.service';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { Observable, Subject, interval } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { DynamicHelpListComponent } from '../doctor-other-info/dynamic-help-list/dynamic-help-list.component';
@Component({
  selector: 'app-surgery',
  templateUrl: './surgery.component.html',
  styleUrls: ['./surgery.component.scss']
})
export class SurgeryComponent implements OnInit {
  destroysurgery$: Subject<boolean> = new Subject<boolean>();
  private surgery_ds: MatTableDataSource<SurgeryModel>
  @Input() showsurgerymodel: any
  @Output() parentdata: EventEmitter<any> = new EventEmitter();
  isheader: boolean = false;
  private examid: any;
  private editCache: { [key: string]: any } = {};
  private surId: any;
  private surgeryName: any;
  private ShowDoctorName: any;
  private consultantId: any;
  private surgeryTypeCtrl: FormControl;
  private filteredsurgeryTypeArray: any = [];
  private editsurgeryArray: any = [];

  private DoctorCtrl: FormControl;
  private filteredsurgeryArray: Observable<any[]>;
  private surgeryconedit: FormControl;

  // filteredDoctorArray: Observable<any[]>;
  private surgerydata: any = [];
  private showspinner: boolean = false;
  private surgeryMainArray: any = [];
  private examdetailArray: any = [];
  private disablesitel: boolean = true;
  private disablesiter: boolean = true;
  private disablesiteb: boolean = true;
  private disablesiten: boolean = false;
  // emrservice.enabledisablebtnSur:boolean=false;  
  private eyetype: string;
  private selectedSugeryArray: any = [];
  private helplistsergery: any = [];
  private stype: any;
  private sitelist: any
  private qualifierdata:any =[];
  private qualifierName:string =null;
  private qualifierid:any =null;
  private datalist: any = [];

  // searchSurgery:any;
  private displayedColumns_surgery: string[] = ['surgery','qualifierName', 'site', 'surgeon', 'Action'];
  constructor(private service: VoiceRecognitionService,
    private dialogRef: MatDialogRef<SurgeryComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private opdvisitService: OpdVisitService, private datepipe: DatePipe, private authService: AuthService, private dashboardService: DashboardService, private emrservice: EMRService, private dialog: MatDialog, private helplistservice: HelplistService) {
   // this.service.init();
  }


  sitobj = [
    { eye: "Right" },
    { eye: "Left" },
    { eye: "Both" },
    { eye: "None" }
  ]
  checkdisable(type2) {
    if (type2 == 1) {
      this.eyetype = 'LE'
      this.disablesitel = false
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = true;

    } else if (type2 == 2) {
      this.eyetype = 'RE'
      this.disablesitel = true
      this.disablesiter = false;
      this.disablesiteb = true;
      this.disablesiten = true;
    } else if (type2 == 3) {
      this.eyetype = 'BE'
      this.disablesitel = true
      this.disablesiter = true;
      this.disablesiteb = false;
      this.disablesiten = true;
    } else if (type2 == 4) {
      this.eyetype = 'None'
      this.disablesitel = true
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = false;
    }
  }
  ngOnInit(): void {
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.emrservice.enabledisablebtnSur = true;
    this.helplistsergery = [];
    this.eyetype = 'None'
    this.emrservice.share.pipe(takeUntil(this.destroysurgery$)).subscribe((x: any) => {

      if (x == 2) {
        this.examid = this.emrservice.examid;
        //  this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId);
        this.GetSurgeryDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.emrservice.visitid, this.opdvisitService.DoctorIdEmr);
      }
      if (x == 3) {
        this.examid = this.emrservice.examid;
        this.GetSurgeryDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.emrservice.visitid, this.opdvisitService.DoctorIdEmr);
        // this.surgery_ds.data = this.surgerydata.filter(item => item.fK_ExamId == this.emrservice.examid);
        // this.opdvisitService.patientDrdetaill = this.opdvisitService.patientDrdetaill.filter(item => item.pK_ExamId == this.emrservice.examid);
      }
      if (x == 22) {
        this.examid = this.emrservice.examid;
      }
    });
    this.stype = 'A';
    this.surgery_ds = new MatTableDataSource(this.emrservice.surgery.slice());

    // AI Scribe — pre-fill surgeries from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroysurgery$)).subscribe(() => this.consumeAiSurgeries());
    interval(1500).pipe(takeUntil(this.destroysurgery$)).subscribe(() => this.consumeAiSurgeries());

    this.helplistsergery = this.helplistservice.surgeryList.filter(item => item.isActive == true);
    // this.get_All_surgeries();
    this.SurgeryTypeControll();
    this.getDoctorBrach();
    this.updateEdit();
    // this.doctorControll();
    // this.getSite();
    this.emrservice.transferArraysurgery.pipe(takeUntil(this.destroysurgery$)).subscribe((item: any) => {
      if (item.length > 0) {
        if (this.examid == null || this.examid == undefined) {
          this.examid = 0;
        }
        this.emrservice.enabledisablebtnSur = false;
        item.forEach(itemdata => {
          this.surgeryMainArray.push({
            "pK_TranId": 0,
            "fK_ExamId": this.examid,
            "fK_SurgeryId": itemdata.fK_surgeryId,
            "fK_QualifierId": 0,
            "fK_SurgeonId": this.opdvisitService.DoctorIdEmr ? this.opdvisitService.DoctorIdEmr : 0,
            "remarks": itemdata.remarks ? itemdata.remarks : 'None',
            'pK_SynchId': itemdata.pk_SynchId,
            'oldExamId': 0,
            'isDeleted': 0,
            'surgeryName': itemdata.surgeryName,
            'qualifierName': itemdata.qualifierName,
            'SurgeonName': this.opdvisitService.doctors.filter(item => item.userId == this.opdvisitService.DoctorIdEmr)[0].userName,
            'isEdit': itemdata.isEdit,
            'eye': itemdata.remarks ? itemdata.remarks : 'None'
          })
        })

        var resultt = this.surgeryMainArray.reduce((unique, o) => {
          if (!unique.some(obj => obj.surgeryName === o.surgeryName && obj.fK_SurgeryId === o.fK_SurgeryId)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.surgery_ds.data = resultt;
      }
    });
    this.qualifierdata=[];
    this.catTypeControll();
    this.getSite();
    this.getqulifier();
    this.emrservice.componentClicked$.subscribe(() => {
      if(!this.emrservice.enabledisablebtnSur){
        setTimeout(()=>{ 
          if( this.emrservice.examid >0){
            this.examid = this.emrservice.examid;
            this.SaveAll(true,1);
          }
          }, 200);
       
      }
    });
  }

  /** AI Scribe: pull surgeries from the pending workup into this grid, then clear. */
  consumeAiSurgeries(): void {
    const p = this.emrservice.aiWorkupPending;
    if (!p || !p.surgeries || !p.surgeries.length) { return; }
    const shown = (this.surgery_ds && this.surgery_ds.data) || [];
    if (shown.some((r: any) => r && r.aiSuggested)) { return; }
    this.surgeryMainArray = shown.slice();
    const master = (this.helplistservice && this.helplistservice.surgeryList) || [];
    const surgeonId = this.opdvisitService.DoctorIdEmr || 0;
    let surgeonName = '';
    try {
      const docs = this.opdvisitService.doctors || [];
      const dm = docs.filter((it: any) => it.userId == surgeonId)[0];
      surgeonName = dm ? dm.userName : '';
    } catch (e) { surgeonName = ''; }
    p.surgeries.forEach((r: any) => {
      const m = this.matchSurgeryMaster(master, r.surgeryName);
      this.surgeryMainArray.push({
        pK_TranId: 0, fK_ExamId: this.examid || 0,
        fK_SurgeryId: m ? m.pkSurgeryId : 0,
        fK_QualifierId: null, fK_SurgeonId: surgeonId,
        remarks: r.remarks || r.eye || 'None', pK_SynchId: 0, oldExamId: 0,
        isDeleted: 0, surgeryName: m ? m.surgeryName : (r.surgeryName || ''),
        qualifierName: '', SurgeonName: surgeonName, isEdit: false,
        eye: r.eye || 'None', aiSuggested: true, aiUnmatched: !m,
      });
    });
    this.surgery_ds.data = this.surgeryMainArray.slice();
    this.emrservice.enabledisablebtnSur = false;
  }

  /** Per-tab AI fill — applies only this section's slice. */
  aiFillSurgeries(s: any): void { this.emrservice.applyAiWorkup({ surgeries: (s && s.surgeries) || [] }); }

  /** Best-effort name -> surgery master match (exact, then contains). */
  private matchSurgeryMaster(list: any[], name: string): any | null {
    if (!name || !list || !list.length) { return null; }
    const n = name.toLowerCase().trim();
    let m = list.find((s) => (s.surgeryName || '').toLowerCase().trim() === n);
    if (!m) { m = list.find((s) => (s.surgeryName || '').toLowerCase().includes(n) || n.includes((s.surgeryName || '').toLowerCase())); }
    return m || null;
  }

 getqulifier(){
  this.emrservice.getquliferdetailid(0).pipe(takeUntil(this.destroysurgery$)).subscribe(data => {
    if(data.length >0){
      this.qualifierdata = data.filter(item=>item.isActive ==true);
    }
    
  },err =>{
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  })
 }
  ngOnDestroy() {
    this.destroysurgery$.next(true);
    this.destroysurgery$.unsubscribe();
    this.helplistsergery = [];
    this.surgeryMainArray = [];
    this.examdetailArray = [];
    this.filteredsurgeryTypeArray = [];
    this.surgerydata = [];
    this.datalist = null;
    this.emrservice.transferArraysurgery=null;
  }
  getSite() {
    this.emrservice.getMasterSite().pipe(takeUntil(this.destroysurgery$)).subscribe(data => {
      this.sitelist = data;

    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  searchType(event) {
    this.stype = event;
  }
  filtersurgerydataa(event, type) {
    if (event !== undefined && event !== null){
      if (event.length >= 3) {
        this.emrservice.GetSurgeryAll(event, this.stype).pipe(takeUntil(this.destroysurgery$)).subscribe((item: any) => {
          if (type == 2) {
            this.helplistsergery = item;
          } else if (type == 1) {
            this.filteredsurgeryTypeArray = item;
          }
        },err =>{
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
    }
    
  }
  filtersurgerydata(event, type) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (event.target.value.length >= 3) {
        this.emrservice.GetSurgeryAll(event.target.value, this.stype).pipe(takeUntil(this.destroysurgery$)).subscribe((item: any) => {
          if (type == 2) {
            this.helplistsergery = item;
          } else if (type == 1) {
            this.filteredsurgeryTypeArray = item;
          }
        },err =>{
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
    } else {
      const finddata = this.filerdata(this.helplistservice.surgeryList.slice(), event.target.value);
      if (finddata.length > 0) {
        if (type == 2) {
          this.helplistsergery = finddata;
        } else if (type == 1) {
          this.filteredsurgeryTypeArray = finddata;
        }
      } else {
        if (type == 2) {
          this.helplistsergery = [];
        } else if (type == 1) {
          this.filteredsurgeryTypeArray = [];
        }
        if (event.target.value.length >= 3) {
          if (event.target.value != null && event.target.value != '') {
            var pdata = event.target.value
          } else {
            pdata = 0;
          }
          this.emrservice.GetSurgeryAll(pdata, this.stype).pipe(takeUntil(this.destroysurgery$)).subscribe((item: any) => {
            if (type == 2) {
              this.helplistsergery = item;
             
            } else if (type == 1) {
              this.filteredsurgeryTypeArray = item;
            }
          },err =>{
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
        }
      }
    }
  }
  filerdata(items: any[], searchText: string) {
    if (this.stype == 'S') {
      let smallchar = searchText ? searchText.toLowerCase() : '';
      return items ? items.filter(item => item.surgeryName?.toLowerCase().indexOf(smallchar) === 0) : [];
    } else {
      return items ? items.filter(item => item.surgeryName.search(new RegExp(searchText, 'i')) > -1) : [];
    }
  }
  GetFindingGResultByregid(regid) {

    this.emrservice.GetFindingGResultByregid(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).subscribe((x: any) => {
      this.examdetailArray = [];
      // this.emrservice.patientEMRdetail = [];
      this.emrservice.patientEMRdetail = x;
      this.examdetailArray = this.emrservice.patientEMRdetail.filter(item => item.pK_ExamId == this.emrservice.examid);
      this.GetSurgeryDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.emrservice.visitid, this.opdvisitService.DoctorIdEmr);
    })
  }
  GetSurgeryDetailByRegId(regid, visitid, docid) {
    this.emrservice.GetSurgeryDetailByRegId(regid, visitid, docid).pipe(takeUntil(this.destroysurgery$)).subscribe(
      data => this.success_allsurgeries(data), err => this.failed_allsurgeries(err)
    )
  }
  newsurgery() {
    const dialogRef = this.dialog.open(NewSurgeryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '90vw',
      disableClose: true,
      width: '80%',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroysurgery$)).subscribe(result => {

      if (result.length > 0) {
        this.emrservice.enabledisablebtnSur = true;
        result.forEach(item => {
          this.surgeryMainArray.push({
            "pK_TranId": item.pkTranId,
            "fK_ExamId": 0,
            "fK_SurgeryId": item.pkSurgeryId,
            "fK_QualifierId": 0,
            "fK_SurgeonId": item.fK_SurgeonId ? item.fK_SurgeonId : 0,
            "remarks": item.eye,
            'pK_SynchId': item.pkSynchId,
            'oldExamId': 0,
            'isDeleted': 0,
            'surgeryName': item.surgeryName,
            'qualifierName': item.qualifierName,
            'SurgeonName': item.SurgeonName,
            'isEdit': item.pkTranId >0 ? true :false,
            'eye': item.eye
          })
        })
      }
      var resultt = this.surgeryMainArray.reduce((unique, o) => {
        if (!unique.some(obj => obj.surgeryName === o.surgeryName && obj.fK_SurgeryId === o.fK_SurgeryId)) {
          unique.push(o);
        }
        return unique;
      }, []);
      this.surgery_ds.data = resultt;

    });

  }
  removeDulplicateArray(data) {
    return [... new Set(data)]
  }
  // get_All_surgeries() {
  //   this.emrservice.get_surgeries().subscribe(
  //     data => this.success_allsurgeries(data), err => this.failed_allsurgeries(err)
  //   )
  // }

  success_allsurgeries(data) {

    this.surgeryMainArray = [];
    this.surgerydata = [];
    if (data.length > 0) {
      this.surgery_ds.data = [];
      data.forEach(item => {
        this.surgerydata.push({
          "pK_TranId": item.pK_TranId,
          "fK_ExamId": item.fK_ExamId,
          "fK_SurgeryId": item.fK_SurgeryId,
          "fK_QualifierId": item.fK_QualifierId,
          "fK_SurgeonId": item.fK_SurgeonId,
          "remarks": item.remarks,
          'pK_SynchId': item.pK_SynchId,
          'oldExamId': item.oldExamId,
          'isDeleted': item.isDeleted,
          'surgeryName': item.surgeryName,
          'qualifierName': item.qualifierName,
          'SurgeonName': this.serchdoctor(item.fK_SurgeonId),
          'isEdit':item.pK_TranId >0 ? true :false,
          'eye': item.remarks
        });
      });
      this.surgery_ds.data = this.surgerydata.filter(item => item.fK_ExamId == this.examid);
      this.surgeryMainArray = this.surgery_ds.data;
    } else {
      this.surgery_ds = new MatTableDataSource(this.emrservice.surgery.slice());
    }
    //this.SurgeryTypeControll();
    //this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory.slice());
    this.updateEdit()
  }
  serchdoctor(doctorid) {
    let doctorname = this.opdvisitService.doctors.filter(item => item.userId == doctorid);
    if (doctorname.length > 0) {
      return doctorname[0].userName;
    } else {
      return null;
    }
  }
  failed_allsurgeries(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  //auto complete Surgery
  getsurgeryTypeobj(e: any) {

    var val = e.value;
    if (val != null) {
      let medid = this.filterOpfunction(val);
      this.emrservice.surgeryhistory_added.surgeryName = medid[0].surgeryName;
      this.emrservice.surgeryhistory_added.pkSurgeryId = medid[0].pkSurgeryId;
    } else {
      this.emrservice.surgeryhistory_added.pkSurgeryId = 0;
      this.emrservice.surgeryhistory_added.surgeryName = '';
    }
    // this.emrservice.surgeryhistory_added.surgeryName = val.surgeryName;
    // this.emrservice.surgeryhistory_added.pkSurgeryId = val.pkSurgeryId
    this.stopService(1);
  }

  CheckinputsurgeryType(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.SurgeryTypeControll();
      //  this.opTypeId = 0;
      //  this.findingid = 0;
      this.surgeryName = null;
      this.emrservice.surgeryhistory_added.pkSurgeryId = 0
    }
  }

  SurgeryTypeControll() {
    this.filteredsurgeryTypeArray = [];
    this.filteredsurgeryTypeArray = this.helplistservice.surgeryList.filter(item => item.isActive == true);
    // this.surgeryTypeCtrl = new FormControl();
    // this.filteredsurgeryTypeArray = this.surgeryTypeCtrl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(cat => cat ? this.filterOpfunction(cat) : this.helplistservice.surgeryList.filter(item => item.isActive == true).slice())
    //   );

  }

  filterOpfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.helplistservice.surgeryList.filter(country =>
      (country.surgeryName?.toLowerCase().indexOf(filterValue) === 0) && country.isActive == true);

  }

  //get schedule type
  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroysurgery$)).
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);
      //  this.doctorControll();
    }
    else {
      this.opdvisitService.doctors = data;
      // this.doctorControll();
    }


  }
  failed_doctors(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  //autocomplet
  // doctorControll() {

  //   this.DoctorCtrl = new FormControl();
  //   this.filteredDoctorArray = this.DoctorCtrl.valueChanges
  //     .pipe(
  //       startWith(''),
  //       map(cat => cat ? this.filterdoctorfunction(cat) : this.opdvisitService.doctors.slice())
  //     );

  // }

  // filterdoctorfunction(name: string) {
  //   const filterValue = name.toString().toLowerCase();
  //   return this.opdvisitService.doctors.filter(country =>
  //     country.userName?.toLowerCase().indexOf(filterValue) === 0);

  // }

  getdoctorobj(e: any) {
    var val = e.option.value;
    this.emrservice.surgeryhistory_added.SurgeonName = val.userName;
    this.consultantId = val.userId;

  }

  // CheckinputDoctor(event: any) {

  //   var checkdata = event.target.value;
  //   if (checkdata == "") {
  //     this.doctorControll();
  //     this.consultantId = 0;

  //   }
  // }
  enableButton() {
    this.emrservice.enabledisablebtnSur = false;
  }
  addsurgery() {
    if(Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) {
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){ 
           this.showspinner = false;    
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    if (this.emrservice.surgeryPermission.isAddPermission == true) {
    
      if (this.emrservice.surgeryhistory_added.pkSurgeryId > 0) {
        if (this.examid == null || this.examid == undefined) {
          this.examid = 0;
        }
        var qname=null;
        if(this.emrservice.surgeryhistory_added.fK_QualifierId >0){
          qname =this.qualifierdata.filter(item=>item.pK_QualifierId ==this.emrservice.surgeryhistory_added.fK_QualifierId)[0]?.qualifierName;
        }
        const checkdublicate =this.surgery_ds.data.filter(item=>item.fK_SurgeryId ==this.emrservice.surgeryhistory_added.pkSurgeryId);

       if(checkdublicate.length ==0) {
        this.emrservice.enabledisablebtnSur = false;
        this.surgeryMainArray.push({
          "pK_TranId": 0,
          "fK_ExamId": this.examid,
          "fK_SurgeryId": this.emrservice.surgeryhistory_added.pkSurgeryId,
          "fK_QualifierId": this.emrservice.surgeryhistory_added.fK_QualifierId?this.emrservice.surgeryhistory_added.fK_QualifierId:null,
          "fK_SurgeonId": this.opdvisitService.DoctorIdEmr ? this.opdvisitService.DoctorIdEmr : 0,
          "remarks": this.emrservice.surgeryhistory_added.eye ? this.emrservice.surgeryhistory_added.eye : 'None',
          'pK_SynchId': 0,
          'oldExamId': 0,
          'isDeleted': 0,
          'surgeryName': this.emrservice.surgeryhistory_added.surgeryName,
          'qualifierName': qname,
          'SurgeonName': this.opdvisitService.doctors.filter(item => item.userId == this.opdvisitService.DoctorIdEmr)[0].userName,
          'isEdit': false,
          'eye': this.emrservice.surgeryhistory_added.eye ? this.emrservice.surgeryhistory_added.eye : 'None',
        });

        var resultt = this.surgeryMainArray.reduce((unique, o) => {
          if (!unique.some(obj => obj.surgeryName === o.surgeryName && obj.fK_SurgeryId === o.fK_SurgeryId)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.surgery_ds.data = resultt;
        this.dashboardService.selectedRowIndex = -1;
        this.emrservice.surgeryhistory_added.surgeryName = null;
        this.emrservice.surgeryhistory_added.SurgeonName = null;
        this.emrservice.surgeryhistory_added.fK_QualifierId=null;
        this.emrservice.surgeryhistory_added.eye = '';
        this.consultantId = 0;
        this.emrservice.surgeryhistory_added.pkSurgeryId = 0;
      }else{
        this.dashboardService.openSnackBar("Already exist in the list", "OK");
      }
      } else {
        this.dashboardService.openSnackBar("All fields are required", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
    this.updateEdit();
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
  }
  }

  deleterarray: any = [];
  deletesurgery(row: any) {
    if(Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) {
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){     
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    const index: number = this.surgeryMainArray.indexOf(row);
    if (index !== -1) {
      if (row.pK_TranId == 0) {
        this.surgeryMainArray.splice(index, 1);
        this.surgery_ds.data = this.surgeryMainArray;
        if(this.surgery_ds.data.length ==0){
          this.emrservice.enabledisablebtnSur =true;
        }
       
      //  this.deleteSurgerdaya(row, 1);
      } else {
        if (this.emrservice.surgeryPermission.isDeletePermission == true) {
          this.surgeryMainArray.splice(index, 1);
          this.surgery_ds.data = this.surgeryMainArray;
          this.deleteSurgerdaya(row, 1);
        } else {
          this.dashboardService.openSnackBar("Delete permission denied", "OK");
        }
      }

    }
    if (this.surgeryMainArray.length == 0) {
      this.surgery_ds = new MatTableDataSource(this.emrservice.surgery.slice());
    }
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
  }
  }

  deleteSurgerdaya(rowdata, type) {
    if(Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) {
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){     
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    if (type == 1) {
      if (rowdata.pK_TranId > 0) {
        this.deleterarray.push({
          "PK_TranId": rowdata.pK_TranId,
          "FK_ExamId": rowdata.fK_ExamId,
          "FK_SurgeryId": rowdata.fK_SurgeryId,
          "FK_QualifierId": rowdata.fK_QualifierId ? rowdata.fK_QualifierId : 0,
          "FK_SurgeonId": this.opdvisitService.DoctorIdEmr ? this.opdvisitService.DoctorIdEmr : 0,
          "Remarks": rowdata.eye,
          "IsDeleted": 1,
          "IsEdit":true
        });
      }

    } else {
      rowdata?.forEach(item => {
        if (item.pK_TranId > 0) {
          this.deleterarray.push({
            "PK_TranId": item.pK_TranId,
            "FK_ExamId": item.fK_ExamId,
            "FK_SurgeryId": item.fK_SurgeryId,
            "FK_QualifierId": item.fK_QualifierId ? item.fK_QualifierId : 0,
            "FK_SurgeonId": this.opdvisitService.DoctorIdEmr ? this.opdvisitService.DoctorIdEmr : 0,
            "Remarks": item.eye,
            "IsEdit":true,
            "IsDeleted": 1
          });
        }

      })
    }
    if (this.deleterarray.length > 0) {
      this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
      this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
      this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
      this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
      let payload = {

        DrExam: {
          ...this.opdvisitService.patientDrdetaill[0]

        },

        DrFinding: []
        ,
        DrDiag: [
        ],
        DrPrescrip: [
        ],
        DrInvest: []
        , DrSurgery: this.deleterarray
      }
      this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroysurgery$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.deleterarray = [];
          if (type == 2) {
            this.surgeryMainArray = [];
            this.surgery_ds = new MatTableDataSource(this.emrservice.surgery.slice());
          }
          this.GetSurgeryDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.emrservice.visitid, this.opdvisitService.DoctorIdEmr);
          this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
          this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
          document.getElementById("surgeryModal").style.display = "None";
        }else if(data['statusCode'] == 10) {
          this.dashboardService.openSnackBar("Already exists in the list", "OK");
        }  else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },
        err => {
          this.showspinner = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }

        });
    } else {
      if (type == 2) {
        this.surgeryMainArray = [];
        this.surgery_ds = new MatTableDataSource(this.emrservice.surgery.slice());
      }
      this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
      document.getElementById("surgeryModal").style.display = "None";
    }
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
  }
  }
  //delete pop up open 
  Cancelpopup(type) {
    if (type == 1) {
      if (this.emrservice.surgeryPermission.isDeletePermission == true) {

        document.getElementById("surgeryModal").style.display = "Block";
      } else {
        this.dashboardService.openSnackBar("Delete permission denied", "ok");
      }

    } else {
      document.getElementById("surgeryModal").style.display = "None";
    }

  }
  drSergerydata: any = [];
  SaveAll(event ,type) {
    if(Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) { 
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){     
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
  
    // this.emrservice.open_loader_Dialog(); 
    if (this.emrservice.surgeryPermission.isAddPermission == true) {
      this.drSergerydata = [];
      if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
        if (this.examid == null || this.examid == undefined) {
          this.examid = 0;
        }
        if (this.opdvisitService.patientdetails.pkRegId) {

          if (this.surgeryMainArray.length > 0) {
            if(type ==0){
              const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
            button.setAttribute('disabled', true);
            this.showspinner = true;
            }
          
            this.surgery_ds.data.forEach(item => {
              this.drSergerydata.push({
                "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
                "FK_ExamId": this.examid,
                "FK_SurgeryId": item.fK_SurgeryId,
                "FK_QualifierId": item.fK_QualifierId ? item.fK_QualifierId : 0,
                "FK_SurgeonId": item.fK_SurgeonId,
                "Remarks": item.eye,
                "IsDeleted": item.isDeleted ? item.isDeleted : 0,
                "IsEdit":item.pK_TranId >0 ? true : false
              });
            });


            this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
            this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
            this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
            this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
            this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
            let payload = {

              DrExam: {
                ...this.opdvisitService.patientDrdetaill[0]

              },

              DrFinding: []
              ,
              DrDiag: [
              ],
              DrPrescrip: [
              ],
              DrInvest: []
              , DrSurgery: this.drSergerydata
            }
            try {
              this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroysurgery$)).subscribe(data => {
                this.showspinner = false;
                if (data['statusCode'] == 1) {
                  if (this.examid > 0) {
                    this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup', 'true', 'DR');
                  } else {
                    this.emrservice.savedrWorkupTrackingSatus('Doctor Workup', 'false', 'DR');
                  }
                  this.examid = data['id'];
                  this.emrservice.examid = data['id'];
                  // this.emrservice.content.next('2');
                  this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
                  this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
                  this.GetSurgeryDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.emrservice.visitid, this.opdvisitService.DoctorIdEmr);
                  this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
                  this.emrservice.enabledisablebtnSur = true;
                }else if(data['statusCode'] == 10) {
                  this.dashboardService.openSnackBar("Already exists in the list", "OK");
                }  else {
                 
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              },
                err => {
                  this.showspinner = false;
                  // this.dialog.closeAll();
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                  } 
                  else if(err.error.statusCode == 422){
                    this.dashboardService.openSnackBar(err.error.message,"OK");
                  }
                  else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                });
            }
            catch (error) {
              this.showspinner = false;
              // this.dialog.closeAll();
            }
          }
          else {
            this.showspinner = false;
            // this.dialog.closeAll();
            
            this.dashboardService.openSnackBar("Please Select Surgery", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Please Select Patient", "OK");
        }

      } else {
        this.dashboardService.openSnackBar("Please Select Visit List", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
  }
  }

  //Surgery Selection
  surgerySelection() {
    if (this.emrservice.surgeryPermission.isAddPermission == true) {
      this.service.Surgerytext = '';
      this.qualifierName=null;
      this.qualifierid =null;
      document.getElementById("surgerySelectionModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  CancelSurgerySelection() {
    this.emrservice.enabledisablebtnSur = true;
    if (this.selectedSugeryArray.length > 0) {

      for (var i = 0; i < this.selectedSugeryArray.length; i++) {
        let itemdata = this.helplistsergery.filter(item => item.pkSurgeryId == this.selectedSugeryArray[i].pkSurgeryId);
        if (itemdata) {

          itemdata[0].isEdit = null;

        }
      }
    }
    this.selectedSugeryArray = [];

    document.getElementById("surgerySelectionModal").style.display = "none";
  }


  //Surgery Master
  surgeryMaster() {
    document.getElementById("surgeryMasterModal").style.display = "block";
  }
  CancelSurgeryMaster() {
    document.getElementById("surgeryMasterModal").style.display = "none";
  }


  //Search Record
  searchRecord() {
    document.getElementById("searchRecordModal").style.display = "block";
  }
  CancelSearchRecord() {
    document.getElementById("searchRecordModal").style.display = "none";
  }
  AddNewsurgeriespopup(): void {
    const dialogRef = this.dialog.open(AddNewSurgeryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '60vw',
      height: 'auto',
      width: '60%',
      disableClose: true
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroysurgery$)).subscribe(result => {
      if (result != 0) {
        // this.getallsurgeries();
      }

    });
  }
  showSurgeryOptions(event: MatCheckboxChange, row: any, i): void {
  
    if (event.checked == true) {
      const checkdublicate=this.surgery_ds.data.filter(item=>item.fK_SurgeryId ==row.pkSurgeryId);
      if(checkdublicate.length ==0){
      this.helplistsergery[i].isEdit = false;
      this.selectedSugeryArray.push({
        ...row,
        'eye': this.eyetype,
        'qualifierName':this.qualifierName?this.qualifierName:null,
        'fK_QualifierId':this.qualifierName ?this.qualifierid:null
      });
      this.stopService(2);
    }else{
      this.helplistsergery[i].isEdit = null;
      this.dashboardService.openSnackBar("Already exist in the surgery list", "OK");
    }
    } else {
      this.stopService(2);
      this.helplistsergery[i].isEdit = null;
      this.selectedSugeryArray = this.selectedSugeryArray.filter(item => item.pkSurgeryId != row.pkSurgeryId);

    }
   
 
  }
  selectDeleterow(row: any) {
    const index: number = this.selectedSugeryArray.indexOf(row);
    if (index !== -1) {
      const findindex = this.helplistsergery.findIndex(item => item.pkSurgeryId == row.pkSurgeryId);
      this.helplistsergery[findindex].isEdit = null;
      this.selectedSugeryArray.splice(index, 1);
    }
  }
  transferDataMain() {
    if (this.selectedSugeryArray.length > 0) {
      this.emrservice.enabledisablebtnSur = false;
      if (this.opdvisitService.DoctorIdEmr > 0) {
        if (this.examid == null || this.examid == undefined) {
          this.examid = 0;
        }
        for (var i = 0; i < this.selectedSugeryArray.length; i++) {
          let itemdata = this.helplistsergery.filter(item => item.pkSurgeryId == this.selectedSugeryArray[i].pkSurgeryId);
          if (itemdata) {

            itemdata[0].isEdit = null;

          }
          this.surgeryMainArray.push({
            "pK_TranId": 0,
            "fK_ExamId": this.examid,
            "fK_SurgeryId": this.selectedSugeryArray[i].pkSurgeryId,
            "fK_QualifierId": this.selectedSugeryArray[i].fK_QualifierId?this.selectedSugeryArray[i].fK_QualifierId:0,
            "fK_SurgeonId": this.opdvisitService.DoctorIdEmr ? this.opdvisitService.DoctorIdEmr : 0,
            "remarks": this.selectedSugeryArray[i].eye,
            'pK_SynchId': 0,
            'oldExamId': 0,
            'isDeleted': 0,
            'surgeryName': this.selectedSugeryArray[i].surgeryName,
            'qualifierName': this.selectedSugeryArray[i].qualifierName,
            'SurgeonName': this.opdvisitService.doctors.filter(item => item.userId == this.opdvisitService.DoctorIdEmr)[0].userName,
            'isEdit': false,
            'eye': this.selectedSugeryArray[i].eye,
          });
        }



        var resultt = this.surgeryMainArray.reduce((unique, o) => {
          if (!unique.some(obj => obj.surgeryName === o.surgeryName && obj.fK_SurgeryId === o.fK_SurgeryId)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.surgery_ds.data = resultt;
        this.selectedSugeryArray = [];

        document.getElementById("surgerySelectionModal").style.display = "none";


      } else {
        this.dashboardService.openSnackBar("Doctor Id is Required", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Surgery", "OK");
    }
  }

  startService(type) {

    if (type == 1) {
      this.service.Surgerytxt = '';
      this.service.start('Surgery');
    } else {
      this.service.Surgerytext = '';
      this.service.start('Surgery Search');
    }

  }

  stopService(type) {
    // this.searchSurgery = this.service.Surgerytext;
    if (type == 1) {
      this.service.stop('Surgery');
      this.filtersurgerydataa(this.service.Surgerytxt, 1);
    } else {
      this.service.stop('Surgery Search');
      if (this.service.Surgerytext) {
        this.filtersurgerydataa(this.service.Surgerytext, 2);
      }
    }
  }
  clearsearchTxt() {
    this.service.Surgerytxt = '';
  }
  closedialog() {
    this.dialogRef.close();
  }

  getqlifierTypeobjedit(e: any) {
    this.editCache[this.surId].data.qualifierName = e.option.value;
    this.editCache[this.surId].data.fK_QualifierId = e.option.id;
  }
  getSurgeryTypeobjedit(e: any) {
    this.editCache[this.surId].data.surgeryName = e.option.value;
    this.editCache[this.surId].data.fK_SurgeryId = e.option.id;
  }
  getQulifTypeobjedit(e: any) {
    this.qualifierName = e.option.value;
    this.qualifierid =e.option.id;
  }
  updateEdit(): void {
    this.surgery_ds.data.forEach((item, index) => {
   
      const id = index;
      this.editCache[id] = {
        edit: false,
        data: { ...item }
      };
    });

  }
  Edit(index) {
    if (this.emrservice.surgeryPermission?.isModifyPermission == true) {
      const id = index;
      this.updateEdit();
      this.surId = id;
      this.editCache[id].edit = true;
    } else {
      this.dashboardService.openSnackBar("Modify permission denied", "OK");
    }
  }


  cancelEdit(idx): void {
    const id = idx;
    this.editCache[id].edit = false;
  }



  saveEdit(idx): void {
    if(Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) {
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){     
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    
    const id = idx
    this.editsurgeryArray = [];
    let editlist = this.editCache[id].data;
    if (this.examid == null || this.examid == undefined) {
      this.examid = 0;
    }
    this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
    this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
    this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
    this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
    this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
    if (this.surgeryMainArray.length > 0) {
      this.editsurgeryArray.push({
        "PK_TranId": editlist.pK_TranId ? editlist.pK_TranId : 0,
        "FK_ExamId": this.examid,
        "FK_SurgeryId": editlist.fK_SurgeryId,
        "FK_QualifierId": editlist.fK_QualifierId ? editlist.fK_QualifierId : 0,
        "FK_SurgeonId": editlist.fK_SurgeonId,
        "Remarks": editlist.eye,
        "IsDeleted": 0,
        "IsEdit": editlist.pK_TranId >0? true : false,
      });
      
      let payload = {

        DrExam: {
          ...this.opdvisitService.patientDrdetaill[0]

        },

        DrFinding: []
        ,
        DrDiag: [
        ],
        DrPrescrip: [
        ],
        DrInvest: []
        , DrSurgery: this.editsurgeryArray
      }

      this.editCache[id].edit = false;

      try {
        this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroysurgery$)).subscribe(data => {
       
          if (data['statusCode'] == 1) {
            if (this.examid > 0) {
              this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup', 'true', 'DR');
            } else {
              this.emrservice.savedrWorkupTrackingSatus('Doctor Workup', 'false', 'DR');
            }
            this.examid = data['id'];
            this.emrservice.examid = data['id'];
            this.GetSurgeryDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.emrservice.visitid, this.opdvisitService.DoctorIdEmr);
            this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
            this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
            this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
            this.emrservice.enabledisablebtnSur = true;
          }else if (data['statusCode'] == 10){
            this.dashboardService.openSnackBar("Already Exist in the list", "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        },
          err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }

          });
      }
      catch (error) {
      }
    }
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
  }
  }

  catTypeControll() {
    this.surgeryconedit = new FormControl();
    this.filteredsurgeryArray = this.surgeryconedit.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filtersurgeryfun(cat) : this.helplistsergery.slice())
      );
  }

  filtersurgeryfun(name: string) {
   
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.helplistsergery.filter(category =>
        category.surgeryName?.toLowerCase().indexOf(name) === 0);
    } else {

      return this.helplistsergery.filter(category =>
        category.surgeryName?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
    }
  }
  CheckinputOpType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.catTypeControll();
    }
  }


  onSitechange(e: any, index: number) {
    if (e != null) {
      this.surgeryMainArray[index].eye = e;
      this.surgery_ds.data = this.surgeryMainArray;
    }
  }





  refReasondyamicPOpup(parameter, type) {
    this.emrservice.enabledisablebtnSur = false;
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroysurgery$)).subscribe(result => {

      if (result != 0) {
        this.emrservice.enabledisablebtnSur = false;       
         if (type == 1) {
          this.opdvisitService.patientDrdetaill[0].immunization = result;
        } else if (type == 2) {
          this.opdvisitService.patientDrdetaill[0].fallRisk = result;
        } else if (type == 3) {
          this.opdvisitService.patientDrdetaill[0].personalRemarks = result;
        } else if (type == 5) {
          this.opdvisitService.patientDrdetaill[0].drRemarks = result;
        } else if (type == 6) {
          this.opdvisitService.patientDrdetaill[0].remarksForCounselor = result;
        } else if (type == 7) {
          this.opdvisitService.patientDrdetaill[0].investigationRemarks = result;
        } else if (type == 8) {
          this.opdvisitService.patientDrdetaill[0].managmentRemarks = result;
        } else if (type == 9) {
          this.opdvisitService.patientDrdetaill[0].gvpType = result;
        } else if (type == 10) {
          this.opdvisitService.patientDrdetaill[0].pG_Doctor = result;
        }
      }
    });
  }




  inhouseseugery() {
    this.emrservice
      .inhouseSurgeries(this.opdvisitService.patientdetails.pkRegId)
      .pipe(takeUntil(this.destroysurgery$))
      .subscribe((data:any[]) => {
        this.datalist = data.sort((a, b) => new Date(b.surgeryDate).getTime() - new Date(a.surgeryDate).getTime());
        if (this.datalist && this.datalist.length > 0) {
          document.getElementById("pastSurgeryModal").style.display = "block";
        } else {
          this.dashboardService.openSnackBar("No past surgery found for this patient", "OK");
        }      
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }


  openPastSurgeryModal(): void {
    this.inhouseseugery()
  }

  cancelPastSurgeryModal(): void {
    document.getElementById("pastSurgeryModal").style.display = "none";
  }
  startCounselorService() {
    this.service.CRtext = '';
    this.service.start('Counselor Remarks');
  }
  
  stopCounselorService() {
    this.opdvisitService.patientDrdetaill[0].remarksForCounselor = this.service.CRtext;
    this.service.stop('Counselor Remarks');
    
    this.emrservice.enabledisablebtnSur = false;
  }
  
}
